import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';
import { pushToDatalayer, ecomAddToCart, ecomRemoveFromCart } from '../wooscripts/gtmEnchanced';
import CheckoutOrderInfo from  '../Components/Checkout.OrderInfo'
class Cart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingQuantity: {},
            removingRow: {},
        };
    }

    onQuantityChange(rowSystemId, quantity) {
        this.setState(previousState => ({
            ...previousState,
            editingQuantity: {
                ...previousState.editingQuantity,
                [rowSystemId]: quantity,
            }
        }));
    }

    handleUpdateClick(rowSystemId, currentQuantity, newQuantity) {
        if (currentQuantity == newQuantity) {
            return;
        }
        this.props.updateOrderRowQuantity(rowSystemId, { quantity: newQuantity });
    }

    onDeleteRequest(rowSystemId, showDeleteButton) {
        this.setState(previousState => ({
            ...previousState,
            removingRow: {
                ...previousState.removingRow,
                [rowSystemId]: showDeleteButton,
            }
        }));
    }

    handlePriceChange(order, price) {
        this.props.updateOrderRowPrice(order.rowSystemId, { salesPrice: price });
    }

    render() {
        const { editingQuantity, removingRow } = this.state;

        return <div className="row checkout__container">
                <div className="small-12 simple-table">
                    { this.props.orderRows && this.props.orderRows.map(orderRow => (
                        <div className="row small-unstack no-margin checkout-cart__row" key={orderRow.rowSystemId}>
                            <div className="columns medium-2 small-12 checkout-cart__image-wrapper">
                                <img className="checkout-cart__image" src={orderRow.image} alt={orderRow.name} />
                            </div>
                            <div className="columns medium-6 small-12 checkout-cart__title-and-quantity">
                                <div className="checkout-cart__product-title">
                                    <a className="product-title" href={orderRow.url}>{orderRow.name}</a>
                                </div> 
                            <div className='article-number'><p>{translate('product.articlenumber')}</p>{orderRow.articleNumber}
                            </div>
                             <div className='stock'>
                                <div className={"stock-color " + (orderRow.isInStock ? 'in-stock' : 'out-of-stock')}></div>
                                     <div className="stock-count">{orderRow.stockStatusDescription}</div> 
                            </div>
                            <div className='checkout-cart__price-per-product'><p>{translate('product.priceperunit')+ ":"}</p>
                                    {orderRow.campaignPrice ? (
                                        <Fragment>
                                            <div className='checkout-cart__original-price'>
                                            {orderRow.salesPrice.toFixed(0) + " " + orderRow.currency}</div>
                                            <div className='checkout-cart__campaign-price'>{orderRow.campaignPrice}</div>
                                        </Fragment>
                                    ) :
                                    <div className='checkout-cart__price'>{orderRow.salesPrice.toFixed(0) + " " + orderRow.currency}</div>}
                                </div>
                                <div className="cart-quantity-wrapper">
                                    {!orderRow.isFeeRow && !orderRow.isServiceRow ? (
                                    <>
                                        <div className="quantity-input-row" key={orderRow.rowSystemId}>
                                        <div className="checkout-cart-row-quantity">
                                            <button
                                            type="button"
                                            className="minus-cart-quantity"
                                            onClick={event =>
                                                this.handleUpdateClick(
                                                orderRow.rowSystemId,
                                                orderRow.quantity--,
                                                editingQuantity[orderRow.rowSystemId] ||
                                                orderRow.quantity--
                                                )
                                            }
                                            >
                                            &minus;
                                            </button>
                                            {orderRow.isFreeGift ? (
                                            <div> {orderRow.quantity} </div>
                                            ) : (
                                                <div className="input-holder">
                                                <input
                                                className="checkout-cart__input"
                                                type="number"
                                                min="1"
                                                maxLength={3}
                                                disabled
                                                value={
                                                    editingQuantity[orderRow.rowSystemId] || orderRow.quantity
                                                }
                                                onChange={event =>
                                                    this.onQuantityChange(
                                                    orderRow.rowSystemId,
                                                    event.target.value,
                                                    )
                                                }
                                                />
                                                </div>
                                            )}
                                            <button
                                            type="button"
                                            className="plus-cart-quantity"
                                            onClick={event =>
                                                this.handleUpdateClick(
                                                orderRow.rowSystemId,
                                                orderRow.quantity++,
                                                editingQuantity[orderRow.rowSystemId] ||
                                                orderRow.quantity++
                                                )
                                            }
                                            >
                                            +
                                            </button>
                                        </div>
                                        </div>
                                    </>
                                    ) : (
                                        <>
                                        <div className="quantity-input-row" key={orderRow.rowSystemId}>
                                            <div className="checkout-cart-row-quantity">
                                            <button
                                                type="button"
                                                disabled
                                                className="minus-cart-quantity"
                                            />
                                            <input
                                                type="number"
                                                disabled
                                                className="checkout-cart__input"
                                                value={orderRow.quantity}
                                            />

                                            <button
                                                type="button"
                                                disabled
                                                className="plus-cart-quantity"
                                            />
                                            </div>
                                        </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="columns medium-4 small-12 checkout-cart__price-and-remove">
                                <div>
                                    {orderRow.campaignPrice ? (
                                        <Fragment>
                                            <div className='checkout-cart__original-price'>
                                                {`${orderRow.totalOriginalPrice}`}</div>
                                            <div className='checkout-cart__campaign-price'>{orderRow.totalPrice}</div>
                                        </Fragment>
                                    ) :
                                    <div className='checkout-cart__price'>{`${orderRow.totalPrice}`}</div>}
                                </div>

                            </div>
                            {/* Admin row */}
                            {this.props.isAdmin &&
                            <div className="columns medium-12 small-12 admin-row">
                                    <div className="change-price">
                                        <h3 className="title">{translate('checkout.cart.changeoriginalprice')}</h3>
                                        <div>
                                            <input type="string" value={orderRow.salesPrice.toFixed(0)}
                                                onChange={(event)=> this.handlePriceChange(orderRow, event.target.value, orderRow.quantity)}>
                                            </input>
                                            <div className="checkout-cart__price">{`${orderRow.currency}`}</div>
                                        </div>
                                    </div>
                                    <div className="purchase-prices">
                                        <h3 className="title">{translate('checkout.cart.purchaseprices')}</h3>
                                        {/* Inköpspriser */}
                                        {this.props.isAdmin && orderRow.purchasePrices && <div>
                                            {orderRow.purchasePrices.map(priceInfo => {
                                            return <div key={priceInfo.id}>
                                            <p className="text-semi-bold">{priceInfo.name}</p>
                                            <p>{priceInfo.price ? priceInfo.price + " " +  priceInfo.currency : translate("price.missing")}</p>
                                            </div>;
                                        })}
                                        </div>}
                                    </div>
                            </div>
                            }
                        </div>
                    ))}
                    {/* Summary rows */}
                    <CheckoutOrderInfo {...this.props}></CheckoutOrderInfo>
                </div>
            </div>;
    }
}

export default Cart;
